var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeHide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.359,
    height: 19.971,
    viewBox: "0 0 23.359 19.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1.586)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.68,3l16,16",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.055,4.79a1,1,0,0,1,1.271-.619A14.359,14.359,0,0,1,22.892,10.8a3.523,3.523,0,0,1,.34,2.7,1,1,0,0,1-1.927-.534,1.522,1.522,0,0,0-.147-1.165,12.37,12.37,0,0,0-6.483-5.736A1,1,0,0,1,14.055,4.79Zm-5.3.151a1,1,0,0,1-.55,1.3,12.6,12.6,0,0,0-6,5.554,1.522,1.522,0,0,0,0,1.516c2.222,3.871,5.691,6.242,9.478,6.242A10.135,10.135,0,0,0,18.915,16.3a1,1,0,0,1,1.426,1.4,12.13,12.13,0,0,1-8.661,3.856c-4.686,0-8.735-2.931-11.212-7.246a3.522,3.522,0,0,1,0-3.508,14.585,14.585,0,0,1,6.98-6.412A1,1,0,0,1,8.75,4.941Z",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.589,11.825a3,3,0,1,1-2.29-2.2",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHide);
export default __webpack_public_path__ + "static/media/eye-hide.792d6e4e9e21d4edebe2fcdedf495060.svg";
export { ForwardRef as ReactComponent };